'use client'

import { TagThumbnail } from '@/components/ui/tag-thumbnail'
import { useX2CoolCashProducts } from '@/hooks/react-query/products/use-collection-products'
import { ImageHelper } from '@/lib/helpers/image.helper'
import { stringToSlug } from '@/lib/utils'
import { ETags } from '@/types/product'
import Image from 'next/image'
import { useMemo } from 'react'
import { useProductCardContext } from './context/product-card-context'

const tagBackground = {
  [ETags.PREORDER]: 'bg-neutral-900',
  [ETags.CLEANDYE]: 'bg-neutral-900',
  [ETags.LIMITED_QUANTITY]: 'bg-neutral-900',
  [ETags.SALE]: 'bg-secondary',
  [ETags.BAN_CHAY]: 'bg-neutral-900',
  [ETags.NEW]: 'bg-primary-500',
  [ETags.BESTSELLER]: 'bg-neutral-900',
  [ETags.LIMITED]: 'bg-neutral-900',
  [ETags.PREMIUM]: 'bg-neutral-900',
  [ETags.DANG_MUA]: 'bg-neutral-900',
}

export const ProductItemHeader = () => {
  const { product } = useProductCardContext()
  const { data: x2CoolCashProducts } = useX2CoolCashProducts()

  //TODO: chuyển về backend
  const isX2CoolCash = useMemo(() => {
    if (!x2CoolCashProducts) return false

    const idSet = new Set(x2CoolCashProducts.product_ids)
    const collectionSet = new Set(x2CoolCashProducts.collection_list)

    return (
      idSet.has(product.id) ||
      product.collections?.some((c) => collectionSet.has(c))
    )
  }, [x2CoolCashProducts, product])

  // const isFriday = new Date().getDay() === 5

  const isFriday = false

  const isShowX2CoolCashTags = isX2CoolCash || isFriday

  // const isFreeShipping = product.regular_price >= 200000

  if (product.tags.length === 0 && !isShowX2CoolCashTags) return null

  // good price
  const productTags = Array.isArray(product.tags)
    ? product.tags
    : Object.keys(product.tags || {})
  // const isGoodPrice = product.regular_price < 200000

  // if (isGoodPrice && process.env.NEXT_PUBLIC_GOOD_PRICE_ENABLED) {
  //   // chir ganws tag good price nếu chưa có, không có tag outlet và nằm trong collection
  //   if (!productTags.includes('Outlet') && !productTags.includes('goodprice')) {
  //     productTags.push('goodprice')
  //     //nếu có cả goodprice và isShowX2CoolCashTags thì xoá toàn bộ tags khác trừ 2 tác này
  //     if (isShowX2CoolCashTags) {
  //       productTags = ['goodprice']
  //     }
  //   }
  // }

  return (
    <div className='absolute left-0 right-3 top-3 flex flex-col items-end gap-1 md:gap-2'>
      {productTags.map((tag) =>
        tag === 'Good Price' ? (
          <Image
            key={tag}
            src={ImageHelper.getImageUrlCdn('/image/July2025/mceclip6_30.png')}
            alt='Good Price'
            width={49}
            height={26}
            className='h-auto w-1/5 md:w-1/6 2xl:w-[12%]'
            unoptimized
          />
        ) : (
          <TagThumbnail
            key={tag}
            title={tag}
            variant='primary'
            size='small'
            className={
              tagBackground[stringToSlug(tag) as keyof typeof tagBackground]
            }
          />
        )
      )}
      {isShowX2CoolCashTags && (
        <Image
          src={ImageHelper.getImageUrlCdn(
            '/image/November2024/mceclip0_82.png'
          )}
          alt='X2 CoolCash'
          width={24}
          height={24}
          className='h-auto w-1/5 md:w-1/6 2xl:w-[12%]'
          unoptimized
        />
      )}
      {/* {!isFriday && isFreeShipping && (
        <Image
          src={ImageHelper.getImageUrl('/image/November2024/mceclip12_70.png')}
          alt='Free Shipping'
          width={24}
          height={24}
          className='h-auto w-1/4'
          unoptimized
        />
      )} */}
    </div>
  )
}
